import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { BottomNavigation } from '../components/BottomNavigation.js';
import { Navigation } from '../components/Navigation.js';
import { Spinner } from '../components/Spinner.js';
import { useAuth } from '../contexts/AuthContext.js';
import { useStoryblokPreview } from '../contexts/StoryblokPreviewContext.js';
import { StoryLayout } from './StoryLayout.js';

export const AppLayout = () => {
  const { isAuthenticated, isLoading: authIsLoading } = useAuth();
  const { isPreviewMode, isLoading: previewIsLoading } = useStoryblokPreview();
  const location = useLocation();

  // Wait for both auth and preview token validation to complete before deciding
  if (authIsLoading || previewIsLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <Spinner />
      </div>
    );
  }

  // Allow access when authenticated OR when a valid Storyblok preview token is present.
  // The preview bypass only grants access to the page skeleton — no real user data is
  // present in preview mode since there is no authenticated session.
  if (!isAuthenticated && !isPreviewMode) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return (
    <div className="min-h-dvh bg-background pb-20">
      <Navigation />
      <main className="mx-auto max-w-prose px-4 grid gap-4">
        <StoryLayout>
          <Outlet />
        </StoryLayout>
      </main>
      <BottomNavigation />
    </div>
  );
};
